export interface Finding {
  text: string;
}

const FINDING_RE = /<finding\b[^>]*>([\s\S]*?)<\/finding>/gi;

// Mirrors escapeXML/unescapeXML in peai/format.go, ampersand last so that text the server
// escaped twice survives one round trip rather than collapsing to a bare delimiter.
export function decodeEntities(text: string): string {
  return text
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&');
}

export function parseFindings(text: string): Finding[] {
  if (!text) return [];

  const findings: Finding[] = [];
  for (const match of text.matchAll(FINDING_RE)) {
    const inner = (match[1] ?? '').trim();
    if (inner) findings.push({ text: decodeEntities(inner) });
  }
  return findings;
}
